/**
 * @desc matching
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OrderApplyOperationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/outPlan/matching`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
